/**
 * Created by Angelika on 05.09.2017.
 */
import React, {Component} from "react";
import PropTypes from "prop-types";
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import 'videojs-contrib-hls';
import * as errors from '../constants/errors';
import * as videoErrors from '../constants/videoErrors';
import StalkerApiManager from "../api/StalkerApiLoaderManager";

let api = StalkerApiManager.getInstance();
let loader = api.getLoader();

class VideoComponent extends Component {

    constructor(props) {
        super(props);
        this.player = null;
        this.activeTimeout = null;
        this.state = {
            active: false
        };

    }

    componentDidMount() {
        const {channel} = this.props;

        loader.getChannelLink(channel).then(url => {
            this.loadHLSVideo(url);
        });

        // switch (format) {
        //     case formats.MP4:
        //         this.videoNode.src = url;
        //         this.doPlay();
        //         break;
        //
        //     case formats.HLS:
        //         this.loadHLSVideo();
        //         break;
        //
        //     case formats.UNDEFINED_FORMAT:
        //         videoActions.setError(strings.VIDEO_ERROR_POPUP_TITLE_FORMAT, errors.VIDEO_FORMAT_UNDEFINED);
        //         break;
        //
        //     default:
        //         break;
        // }

    }

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    loadHLSVideo(url) {
        let self = this;
        const options = {
            hls: {
                withCredentials: true,
                overrideNative: true
            }
        };
        // const src = "http://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8";
        // const src = "https://d1si4392ltqpn6.cloudfront.net/coco-trailer-2_h1080p/encoded-21-31-06-wed-sep-2017/encoded-21-31-06-wed-sep-2017.m3u8";
        try {
            this.player = videojs(this.videoNode, options, () => {
                videojs.log('onPlayerReady', this);
            });

            this.player.src({
                src: url,
                type: 'application/x-mpegURL'
            });
            // if (!preview) {
            // this.player.loadingSpinner.hide();
            // }

            this.player.on('loadedmetadata', function () {
                // self.initHlsLevels();
            });

            this.player.on('ready', function () {
                // this.addClass('wrapper');
                // if (!video.paused) {
                self.doPlay();
                // }
            });

            this.player.on('error', function (err) {
                self.onHlsError(this.error_.code);
            });

        } catch (error) {
            console.log('loadHLSVideo error happened: ' + error);
        }
    }

    onHlsError(code) {
        let error_description = null;
        switch (code) {
            case videoErrors.MEDIA_ERR_ABORTED:
                error_description = errors.MEDIA_ERR_ABORTED;
                break;

            case videoErrors.MEDIA_ERR_NETWORK:
                error_description = errors.MEDIA_ERR_NETWORK;
                break;

            case videoErrors.MEDIA_ERR_DECODE:
                error_description = errors.MEDIA_ERR_DECODE;
                break;

            case videoErrors.MEDIA_ERR_SRC_NOT_SUPPORTED:
                error_description = errors.MEDIA_ERR_SRC_NOT_SUPPORTED;
                break;

            case videoErrors.MEDIA_ERR_ENCRYPTED:
                error_description = errors.MEDIA_ERR_ENCRYPTED;
                break;

            default:
                break;
        }
        console.log('onHlsError: ', error_description);
    }

    doPlay() {
        if (this.player) {
            this.player.play();
        }
    }

    render() {
        return (
            <div id="player">
                <video ref={node => this.videoNode = node} muted={true}></video>
            </div>
        )
    }
}

VideoComponent.propTypes = {
    channel: PropTypes.any
};

export default VideoComponent;


// WEBPACK FOOTER //
// ./src/components/Video.js